export const Fields = [
  {
    name: 'year',
    type: 'string',
    placeholder: 'Year',
    rules: 'required',
    label: 'Year',
  },
];
